export const CONSTANTS = {
  Refuel: 'Заправка',
  RefreshPage: 'Обновити сторінку',

  NoSalesOrRefuelingWithoutCards:
    'На даний момент немає продажів або заправок без зазначених карток.',
};
